<template>
  <div class="table-wrapper overflow-scroll">
    <table class="ver-table double">
      <tr
        v-for="row in sortedArr"
        :key="row.title"
      >
        <template v-if="row.secContent && row.secTitle">
          <th v-text="row.firstTitle" />
          <td v-text="row.firstContent" />
          <th v-text="row.secTitle" />
          <td v-text="row.secContent" />
        </template>
        <template v-else>
          <th v-text="row.firstTitle" />
          <td 
            colspan="3"
            v-text="row.firstContent"
          />
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      rows: {
        type: Array,
        default: null
      }
    },
    computed: {
      sortedArr() {
        const { rows } = this;
        return rows.map((row, i) => {
          if (i % 2 !== 0) return;
          if (i + 1 === rows.length) return { firstTitle: row.title, firstContent: row.content };
          return {
            firstTitle: row.title,
            firstContent: row.content,
            secTitle: rows[i + 1].title,
            secContent: rows[i + 1].content
          };
        }).filter(row => row !== undefined);
      }
    }
  };
</script>